import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { LocalizationModule } from '@nimbus-library/features/localization/localization.module';
import { SpinnerModule } from '@nimbus-library/features/shared/components/spinner/spinner.module';
import { NimbusIconModule } from '../../nimbus-icon.module';
import { NimbusTooltipModule } from '../../nimbus-tooltip.module';
import { NimbusGridCellComponent } from './nimbus-grid-cell/nimbus-grid-cell.component';
import { NimbusGridCellNoAccessComponent } from './nimbus-grid-cell-no-access/nimbus-grid-cell-no-access.component';
import { NimbusGridColumnComponent } from './nimbus-grid-column/nimbus-grid-column.component';
import { NimbusGridDetailsTemplateDirective } from './nimbus-grid-details-template.directive';
import { NimbusGridPagerComponent } from './nimbus-grid-pager/nimbus-grid-pager.component';
import { NimbusGridComponent } from './nimbus-grid/nimbus-grid.component';
import { MatPaginatorIntlService } from './services/mat-paginator-intl.service';

@NgModule({
  imports: [
    CommonModule,
    LocalizationModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    NimbusIconModule,
    NimbusTooltipModule,
    SpinnerModule,
  ],
  exports: [
    NimbusGridComponent,
    NimbusGridDetailsTemplateDirective,
    NimbusGridCellComponent,
    NimbusGridCellNoAccessComponent,
    NimbusGridColumnComponent,
    NimbusGridPagerComponent,
  ],
  declarations: [
    NimbusGridComponent,
    NimbusGridDetailsTemplateDirective,
    NimbusGridCellComponent,
    NimbusGridCellNoAccessComponent,
    NimbusGridColumnComponent,
    NimbusGridPagerComponent,
  ],
  providers: [{ provide: MatPaginatorIntl, useClass: MatPaginatorIntlService }],
})
export class NimbusGridModule {}
